import styled, { keyframes, css } from 'styled-components';

const animation = keyframes`
  0% {
    bottom: -100%;
  }
  65% {
    bottom: 4px;
  }
  100% {
    bottom: -3px;
  }
`;

export const Wrapper = styled.div`
  ${({ $noAnimation }) => css`
    --wrapper-width: ${$noAnimation ? '150px' : '120px'};
    --border-content: ${!$noAnimation ? 'none' : '""'};
    --snappy-bottom: ${$noAnimation ? '-9px' : '-3px'};
    --snappy-animation: ${$noAnimation ? 'none' : css`${animation} 0.65s ease-out`};
    --hands-bottom: ${$noAnimation ? '-1px' : '3px'};
    --left-hand-left: ${$noAnimation ? '26px' : '13px'};
    --right-hand-right: ${$noAnimation ? '26px' : '15px'};

    width: var(--wrapper-width);
    display: flex;
    justify-content: center;
    position: relative;
    overflow: hidden;

    &::before {
      content: var(--border-content);
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: #DFE2EB;
      z-index: 2;
    }
  `}
`;

export const SnappyAnimation = styled.img`
  position: relative;
  bottom: var(--snappy-bottom);
  width: 88px;
  height: 80px;
  z-index: 1;
  margin-left: 7px;
  animation: var(--snappy-animation);
`;

export const LeftHand = styled.img`
  position: absolute;
  bottom: var(--hands-bottom);
  left: var(--left-hand-left);
  width: 16px;
  height: 8px;
  z-index: 3;
`;

export const RightHand = styled.img`
  position: absolute;
  bottom: var(--hands-bottom);
  right: var(--right-hand-right);
  width: 16px;
  height: 8px;
  z-index: 3;
`;
